// ** UI
import Divider from '@mui/material/Divider';
import Typography, { type TypographyProps } from '@mui/material/Typography';
import MuiListSubheader, { type ListSubheaderProps } from '@mui/material/ListSubheader';
import { styled } from '@mui/material/styles';

// ** Components
import Translations from '@/components/common/Translations';

// ** Types
import type { Settings } from '@/types/contextTypes';
import type { NavSectionTitle } from '@/types/layoutProps';

// ** Interfaces
interface Props {
	navHover: boolean;
	settings: Settings;
	item: NavSectionTitle;
	collapsedNavWidth: number;
	navigationBorderWidth: number;
}

// ** Styled Components
const ListSubheader = styled((props: ListSubheaderProps) => <MuiListSubheader component="li" {...props} />)(
	({ theme }) => ({
		lineHeight: 1,
		display: 'flex',
		position: 'static',
		marginTop: theme.spacing(7),
		marginBottom: theme.spacing(2),
		backgroundColor: 'transparent'
	})
);

const TypographyHeaderText = styled(Typography)<TypographyProps>(({ theme }) => ({
	fontSize: '0.75rem',
	lineHeight: 'normal',
	letterSpacing: '0.21px',
	textTransform: 'uppercase',
	fontWeight: theme.typography.fontWeightMedium
}));

const VerticalNavSectionTitle = ({ item, navHover, settings, collapsedNavWidth, navigationBorderWidth }: Props) => {
	// ** Hook
	const { navcollapsed } = settings;

	return (
		<ListSubheader
			sx={{
				py: 0,
				...(navcollapsed && !navHover
					? {
							pr: (collapsedNavWidth - navigationBorderWidth - 24) / 8 - 1,
							pl: (collapsedNavWidth - navigationBorderWidth - 24) / 8 + 0.25
						}
					: { px: 0 })
			}}
		>
			<Divider
				textAlign="left"
				sx={{
					m: '0 !important',
					lineHeight: 'normal',
					transition: 'width .25s ease-in-out',
					borderColor: (theme) => theme.palette.primary.main,
					borderWidth: 2,
					...(navcollapsed && !navHover
						? {
								width: '80%'
							}
						: {
								width: '100%',
								textTransform: 'uppercase',
								'&:before, &:after': { top: 7, transform: 'none' },
								'& .MuiDivider-wrapper': {
									px: 2.5,
									fontSize: '0.75rem',
									letterSpacing: '0.21px'
								}
							})
				}}
			>
				{navcollapsed && !navHover ? null : item.sectionTitle === null ? null : (
					<TypographyHeaderText noWrap sx={{ color: 'primary.main' }}>
						<Translations text={item.sectionTitle} />
					</TypographyHeaderText>
				)}
			</Divider>
		</ListSubheader>
	);
};

export default VerticalNavSectionTitle;
